




















import Vue from 'vue'
import Navbar from '@/components/ui/Navbar.vue';
export default Vue.extend({
  components: {
    Navbar
  }
})
